import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
	getAlarm(param) {
		return request({
			url: url + '/alarm/page',
			method: 'post',
			data: param,
		})
	},
	getExcel(param) {
		return request({
			url: url + '/alarm/list',
			method: 'post',
			data: param,
		})
	},
	getInfo(param) {
		return request({
			url: url + '/alarm/getOneById',
			method: 'get',
			params: param,
		})
	},
	editAlarm(param) {
		return request({
			url: url + '/workOrder/update',
			method: 'put',
			data: param,
		})
	},

	getCountByState(param) {
		return request({
			url: url + '/workOrder/getCountByState',
			method: 'post',
			data: param,
		})
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/alarm/alarm.js